import { render, staticRenderFns } from "./explore_duo_core_banner.vue?vue&type=template&id=2bfec6fa&scoped=true"
import script from "./explore_duo_core_banner.vue?vue&type=script&lang=js"
export * from "./explore_duo_core_banner.vue?vue&type=script&lang=js"
import style0 from "./explore_duo_core_banner.vue?vue&type=style&index=0&id=2bfec6fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfec6fa",
  null
  
)

export default component.exports